import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import TopicButton from "../components/TopicButton";
import BackButton from "../components/BackButton";

function Topics() {
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch topics from Firestore
  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const unitsRef = collection(db, "units");
        const q = query(unitsRef, orderBy("description"));
        const querySnapshot = await getDocs(q);

        const topicsData = [];
        querySnapshot.forEach((doc) => {
          topicsData.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        setTopics(topicsData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching topics:", error);
        setError("Failed to load topics");
        setLoading(false);
      }
    };

    fetchTopics();
  }, []);

  const handleTopicClick = (topic) => {
    navigate(`/topics/${topic.description}`);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Topics Section */}
      <div className="py-8 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Navigation */}
          <BackButton to="/" />

          {/* Title */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">
              What topic are you interested in?
            </h1>
          </div>

          {loading && (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
              <p className="mt-2 text-gray-600">Loading topics...</p>
            </div>
          )}

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          {!loading && !error && topics.length === 0 && (
            <div className="text-center py-8">
              <p className="text-gray-600">No topics found.</p>
            </div>
          )}

          {!loading && !error && topics.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 justify-items-center">
              {topics.map((topic) => (
                <TopicButton
                  key={topic.id}
                  text={topic.description}
                  onClick={() => handleTopicClick(topic)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Topics;
